var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87636 6.36364L10.1818 8.66182V8.54545C10.1818 7.9668 9.95195 7.41185 9.54278 7.00268C9.13361 6.59351 8.57865 6.36364 8 6.36364H7.87636ZM4.74909 6.94545L5.87636 8.07273C5.84 8.22545 5.81818 8.37818 5.81818 8.54545C5.81818 9.12411 6.04805 9.67906 6.45722 10.0882C6.86639 10.4974 7.42135 10.7273 8 10.7273C8.16 10.7273 8.32 10.7055 8.47273 10.6691L9.6 11.7964C9.11273 12.0364 8.57455 12.1818 8 12.1818C7.03558 12.1818 6.11065 11.7987 5.4287 11.1168C4.74675 10.4348 4.36364 9.50988 4.36364 8.54545C4.36364 7.97091 4.50909 7.43273 4.74909 6.94545ZM0.727273 2.92364L2.38545 4.58182L2.71273 4.90909C1.51273 5.85455 0.567273 7.09091 0 8.54545C1.25818 11.7382 4.36364 14 8 14C9.12727 14 10.2036 13.7818 11.1855 13.3891L11.4982 13.6945L13.6218 15.8182L14.5455 14.8945L1.65091 2M8 4.90909C8.96442 4.90909 9.88935 5.29221 10.5713 5.97416C11.2532 6.65611 11.6364 7.58103 11.6364 8.54545C11.6364 9.01091 11.5418 9.46182 11.3745 9.86909L13.5055 12C14.5964 11.0909 15.4691 9.89818 16 8.54545C14.7418 5.35273 11.6364 3.09091 8 3.09091C6.98182 3.09091 6.00727 3.27273 5.09091 3.6L6.66909 5.16364C7.08364 5.00364 7.52727 4.90909 8 4.90909Z",
    fill: "#939AA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassHide);
export default __webpack_public_path__ + "static/media/passHide.25c85f1fde4a60575bce8328a10ce628.svg";
export { ForwardRef as ReactComponent };